<script setup lang="ts">
const emits = defineEmits<{
  select: [components['schemas']['Box']?]
}>()
const props = defineProps<{
  event: components['schemas']['Event']
  selectedBox?: components['schemas']['Box'] | null
  zone: components['schemas']['Zone']
}>()

const { data: objectList } = await useApi<
  components['schemas']['Box'][]
>(`/ticketing/events/${props.event.slug}/zones/${props.zone.id}/boxes/`)

const boxesByRow = computed(() => {
  if (!objectList.value) return {}

  return Object.groupBy(
    objectList.value,
    (box: components['schemas']['Box']) => box.row ?? 'Sin asignar'
  )
})
</script>

<template>
  <div class="px-4 py-4 overflow-x-auto w-full">
    <div class="flex flex-col items-center min-w-max mx-auto space-y-2">
      <div
        class="bg-black font-mono font-bold mx-auto py-2 rounded text-center text-sm text-white uppercase w-[70%]"
      >
        Escenario
      </div>

      <div
        v-for="(boxesInRow, rowNumber) in boxesByRow"
        :key="rowNumber"
        class="flex flex-nowrap mx-auto space-x-2"
      >
        <div
          v-for="box in boxesInRow"
          :key="box.id"
          class="px-3 py-2 rounded shirk-0 text-center"
          :class="{
            'bg-yellow-200 cursor-not-allowed': box.status === 'locked',
            'bg-red-200  cursor-not-allowed': [
              'blocked-admin',
              'sold',
            ].includes(box.status ?? 'sold'),
            'bg-green-200 cursor-pointer':
              box.status === 'available' && props.selectedBox?.id !== box.id,
            'bg-green-400 cursor-pointer':
              box.status === 'available' && props.selectedBox?.id === box.id,
          }"
          @click="
            () => {
              if (box.status !== 'available') return
              emits('select', box)
            }
          "
        >
          <div class="font-bold">
            {{ box.box_number }}
          </div>

          <div class="text-mono text-surface-500 text-xs uppercase">
            {{ box.capacity }} p
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
